import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { AddIcon, RemoveIcon } from "@snapchat/snap-design-system-icons";

import { badge, icon, negative, neutral, positive } from "./MetricChangeBadge.module.css";

type MetricChangeTone = "positive" | "negative" | "neutral";

interface MetricChangeBadgeProps {
    value: string;
    tone: MetricChangeTone;
    sign?: Exclude<MetricChangeTone, "neutral">;
}

export const MetricChangeBadge: FC<MetricChangeBadgeProps> = ({ value, tone, sign }) => {
    const badgeClassName = tone === "neutral" ? neutral : tone === "negative" ? negative : positive;

    return (
        <span className={`${badge} ${badgeClassName}`}>
            {sign === "positive" ? <AddIcon size={12} className={icon} fill={Colors.Green.V200} /> : null}
            {sign === "negative" ? <RemoveIcon size={12} className={icon} fill={Colors.Red.V200} /> : null}
            {value}
        </span>
    );
};
